import styled from 'styled-components';

const functionTypeToImageMap = {
    NEW_CUSTOMER_CREATED: {
        imageName: 'NEW_CUSTOMER_CREATED',
        label: '고객 추가',
    },
    CUSTOMER_FIRST_BUY_TICKET_ALARM: {
        imageName: 'TICKET_CREATED',
        label: '멤버십/이용권 신규 구매 시',
    },
    CUSTOMER_BUY_RENTAL_TICKET_ALARM: {
        imageName: 'BUY_TICKET',
        label: '대여권/락커 구매 시',
    },
    CUSTOMER_CONTRACT_DONE_ALARM: {
        imageName: 'CONTRACT_DONE',
        label: '계약 완료 시 안내',
    },
    CUSTOMER_REBUY_TICKET_ALARM: {
        imageName: 'CUSTOMER_REBUY_TICKET',
        label: '멤버십/이용권 재구매 시',
    },
    CUSTOMER_NON_ATTENDANCE: {
        imageName: 'CUSTOMER_NON_ATTENDANCE',
        label: '장기 미출석 시',
    },
    CUSTOMER_COUPON_EXPIRE_ALARM: {
        imageName: 'CUSTOMER_COUPON_EXPIRE',
        label: '쿠폰 만료 안내',
    },
    CUSTOMER_ATTENDANCE: {
        imageName: 'CUSTOMER_ATTENDANCE',
        label: '출석 시',
    },
    MEMBER_TICKET_EXPIRE_ALARM: {
        imageName: 'TICKET_EXPIRED_SOON',
        label: '회원권 만료 전',
    },
    LESSON_PROGRAM_EXPIRE_ALARM: {
        imageName: 'TICKET_EXPIRED_SOON',
        label: '프로그램 만료 전',
    },
    RENTAL_PROGRAM_EXPIRE_ALARM: {
        imageName: 'TICKET_EXPIRED_SOON',
        label: '종류 만료 전',
    },
    FACILITY_TICKET_EXPIRE_ALARM: {
        imageName: 'TICKET_EXPIRED_SOON',
        label: '시설권 만료 전',
    },
    ENTRY_TICKET_EXPIRE_ALARM: {
        imageName: 'TICKET_EXPIRED_SOON',
        label: '입장권 만료 전',
    },
    CLASS_TICKET_EXPIRE_ALARM: {
        imageName: 'TICKET_EXPIRED_SOON',
        label: '예약권 만료 전',
    },
    LOCKER_EXPIRE_ALARM: {
        imageName: 'TICKET_EXPIRED_SOON',
        label: '락커 만료',
    },
    LESSON_TICKET_EXPIRE_ALARM: {
        imageName: 'TICKET_EXPIRED_SOON',
        label: '수강권 만료 전',
    },
    SPORTS_EXPIRE_ALARM: {
        imageName: 'TICKET_EXPIRED_SOON',
        label: '대여권 만료',
    },
    CUSTOMER_HOLDING_EXPIRE_ALARM: {
        imageName: 'HOLDING_EXPIRED_SOON',
        label: '홀딩 종료 임박',
    },
    MEMBER_TICKET_EXPIRE_DATE_ALARM: {
        imageName: 'TICKET_EXPIRE_DATE',
        label: '회원권 만료 시',
    },
    LESSON_PROGRAM_EXPIRE_DATE_ALARM: {
        imageName: 'TICKET_EXPIRE_DATE',
        label: '프로그램 만료 시',
    },
    RENTAL_PROGRAM_EXPIRE_DATE_ALARM: {
        imageName: 'TICKET_EXPIRE_DATE',
        label: '종류 만료 시',
    },
    FACILITY_TICKET_EXPIRE_DATE_ALARM: {
        imageName: 'TICKET_EXPIRE_DATE',
        label: '시설권 만료 시',
    },
    ENTRY_TICKET_EXPIRE_DATE_ALARM: {
        imageName: 'TICKET_EXPIRE_DATE',
        label: '입장권 만료 시',
    },
    CLASS_TICKET_EXPIRE_DATE_ALARM: {
        imageName: 'TICKET_EXPIRE_DATE',
        label: '예약권 만료 시',
    },
    LOCKER_EXPIRE_DATE_ALARM: {
        imageName: 'TICKET_EXPIRE_DATE',
        label: '락커 만료 시',
    },
    SPORTS_EXPIRE_DATE_ALARM: {
        imageName: 'TICKET_EXPIRE_DATE',
        label: '대여권 만료 전',
    },
    RENTAL_EXPIRE_DATE_ALARM: {
        imageName: 'TICKET_EXPIRE_DATE',
        label: '대여권 만료 시',
    },
    RENTAL_EXPIRE_DATE_ALARM_WITH_MILEAGE: {
        imageName: 'TICKET_EXPIRE_DATE',
        label: '대여권 만료 시(잔여 마일리지 안내)',
    },
    LESSON_TICKET_EXPIRE_DATE_ALARM: {
        imageName: 'TICKET_EXPIRE_DATE',
        label: '수강권 만료 시',
    },
    CUSTOMER_BUY_RENTAL_SPORTS_TICKET_ALARM: {
        imageName: 'BUY_TICKET',
        label: '대여권 구매 시',
    },
    CUSTOMER_BUY_RENTAL_LOCKER_TICKET_ALARM: {
        imageName: 'BUY_TICKET',
        label: '락커 구매 시',
    },
    CUSTOMER_HOLDING_NEW_ALARM: {
        imageName: 'HOLDING',
        label: '상품 홀딩 시',
    },
    SMART_DAILY_LOCKER_ASSIGNMENT: {
        imageName: 'SMART_DAILY_LOCKER_ASSIGNMENT',
        label: '일일락커 배정 시',
    },
    MEMBER_TICKET_EXPIRE_DATE_ALARM_WITH_MILEAGE: {
        imageName: 'TICKET_EXPIRE_DATE',
        label: '회원권 만료 시(잔여 마일리지 안내)',
    },
    LESSON_TICKET_EXPIRE_DATE_ALARM_WITH_MILEAGE: {
        imageName: 'TICKET_EXPIRE_DATE',
        label: '수강권 만료 시(잔여 마일리지 안내)',
    },
    MEMBER_TICKET_EXPIRE_ALARM_WITH_MILEAGE: {
        imageName: 'TICKET_EXPIRED_SOON',
        label: '회원권 만료 전(잔여 마일리지 안내)',
    },
    LESSON_TICKET_EXPIRE_ALARM_WITH_MILEAGE: {
        imageName: 'TICKET_EXPIRED_SOON',
        label: '수강권 만료 전(잔여 마일리지 안내)',
    },
    LOCKER_EXPIRE_ALARM_WITH_MILEAGE: {
        imageName: 'TICKET_EXPIRED_SOON',
        label: '락커 만료(잔여 마일리지 안내)',
    },
    SPORTS_EXPIRE_ALARM_WITH_MILEAGE: {
        imageName: 'TICKET_EXPIRED_SOON',
        label: '대여권 만료(잔여 마일리지 안내)',
    },
    LESSON_PROGRAM_EXPIRE_ALARM_WITH_MILEAGE: {
        imageName: 'TICKET_EXPIRED_SOON',
        label: '프로그램 만료 전(잔여 마일리지 안내)',
    },
    RENTAL_PROGRAM_EXPIRE_ALARM_WITH_MILEAGE: {
        imageName: 'TICKET_EXPIRED_SOON',
        label: '종류 만료 전(잔여 마일리지 안내)',
    },
    LESSON_BOOK_ALARM: {
        imageName: 'LESSON_BOOKED',
        label: '수업 예약 시',
    },
    LESSON_CANCEL_BOOK_ALARM: {
        imageName: 'LESSON_CANCELED',
        label: '수업 예약 취소 시',
    },
    FACILITY_BOOK_ALARM: {
        imageName: 'LESSON_BOOKED',
        label: '시설 예약 시',
    },
    FACILITY_CANCEL_BOOK_ALARM: {
        imageName: 'LESSON_CANCELED',
        label: '시설 예약 취소 시',
    },
    FACILITY_CHANGE_BOOK_ALARM: {
        imageName: 'LESSON_CHANGED',
        label: '시설 예약 변경 시',
    },
};

export const KakaoPreviewImage = ({ functionType, kakaoTemplate }) => {
    const match = functionTypeToImageMap[functionType];

    if (!match) {
        return <div>[미리보기 이미지 없음]</div>;
    }

    return (
        <div>
            <KakaoPreviewBottom
                src={
                    process.env.PUBLIC_URL +
                    `/assets/images/icon/kakaoTemplate/${match.imageName}.png`
                }
                alt={match.label}
            />
        </div>
    );
};

const KakaoPreviewBottom = styled.img`
    width: 100%;
    height: 80px; 
`;
